/**
 * @typedef Patient
 * @property { number | null } id -
 * @property { string } uuid -
 * @property { string } name -
 * @property { string } surname -
 * @property { string } patronymic -
 * @property { boolean } hasPatronymic -
 * @property { string } birthDay -
 * @property { 'M' | 'F' | null } gender -
 * @property { string } fio -
 * @property { string } age -
 * @property { number | null } ageNumber -
 * @property { boolean } isMain -
 * @property { boolean } isOther -
 * @property { boolean } isEmptyMain -
 */
/** @returns { Patient } - */
const getPatient = () => ({
  id: null,
  uuid: '',
  name: '',
  surname: '',
  patronymic: '',
  hasPatronymic: true,
  birthDay: '',
  gender: null,
  fio: '',
  age: '',
  ageNumber: null,
  isMain: false,
  isOther: false,
  isEmptyMain: false,
})

/** @typedef { Patient[] } PatientList */
/** @returns { PatientList } - */
const getPatientList = () => []

export {
  getPatient,
  getPatientList,
}
